<div class="dialog-container app_security-modal">
  <div class="main-wrapper">
    <div class="setup-img-container">
      <img src="assets/images/security-locker.svg" class="setup-img" />
    </div>

    <div class="setup-text-container">
      <h2 class="setup-text">No&nbsp;<span class="text-[#25508E]">Premium Encryption Keys&nbsp;</span> to show</h2>
      <p class="setup-subtext">Protect your most sensitive files with an additional layer of security.</p>
    </div>
    @if(showAddNewButton){
    <div class="action">
      <button mat-raised-button class="zero-state-setup-btn w-28 h-4" type="button" (click)="openSetupStepper()">Add New</button>
    </div>
    }
  </div>
</div>
